export default {"src":"/_next/static/media/commission-filled.07ccab6f.svg","height":30,"width":30};